module.exports = __webpack_public_path__ + "img/title3.134e18c5.png";